import React from 'react';
import { t } from './i18n';
import { legal } from './legal';

// Pe mobil, .sidebar e display:none, iar footerul legal traieste inauntrul ei.
// Un parinte ascuns scoate tot subarborele din pagina, deci linkurile catre
// politica de confidentialitate si stergerea datelor devin inaccesibile de pe
// telefon. Meta cere ca ele sa fie accesibile, asa ca le randam si aici, o
// singura data pentru toate rolurile (index.js le pune peste toate rutele).
// Adresele stau in `legal.js`, intr-un singur loc pentru toata aplicatia; pe engleza duc direct
// la partea engleza a paginii.
const LINKURI = [
  ['confidentialitate', 'confidentialitate'],
  ['termeni', 'termeniConditii'],
  ['stergere', 'stergereaDatelor'],
  ['cookies', 'cookies'],
];

export default function FooterLegalMobil() {
  return (
    <div className="footer-legal-mobil">
      {LINKURI.map(([care, cheie], i) => (
        <React.Fragment key={cheie}>
          {i > 0 && ' · '}
          <a href={legal(care)} target="_blank" rel="noopener noreferrer">{t('sidebar', cheie)}</a>
        </React.Fragment>
      ))}
    </div>
  );
}
